export const WEEKS_TARGET = 78;
export const ADOPTION_TARGET = 80;
